// This file was generated by lezer-generator. You probably shouldn't edit it.
export const
  StrongText = 1,
  EmText = 2,
  UnderlineText = 3,
  StrikeText = 4,
  SupText = 5,
  SubText = 6,
  Original = 7,
  Hr = 8,
  Document = 9,
  DivBlock = 10,
  DivOpenTag = 11,
  DivOpen = 12,
  AttrList = 13,
  Attr = 14,
  Equals = 15,
  AttrValue = 16,
  DivClose = 18,
  Rate = 19,
  NoteBlock = 20,
  NoteOpenToken = 21,
  NoteCloseToken = 22,
  SizeBlock = 23,
  SizeOpenTag = 24,
  SizeOpenToken = 25,
  SizeCloseToken = 27,
  SpanBlock = 28,
  SpanOpenTag = 29,
  SpanOpenToken = 30,
  SpanCloseToken = 32,
  AlignCenter = 33,
  AlignCenterOpenToken = 34,
  AlignCenterCloseToken = 35,
  AlignLeft = 36,
  AlignLeftOpenToken = 37,
  AlignLeftCloseToken = 38,
  AlignRight = 39,
  AlignRightOpenToken = 40,
  AlignRightCloseToken = 41,
  IncludeBlock = 42,
  IncludeOpen = 43,
  IncludePath = 44,
  IncludePart1 = 45,
  IncludePart2 = 46,
  IncludePart3 = 47,
  IncludeSimplePath = 48,
  FirstIncludeParam = 49,
  IncludeValue = 50,
  StarChar = 51,
  Text = 52,
  LinkURL = 53,
  BracketChar = 54,
  IncludeParam = 55,
  IncludeBar = 56,
  CollapsibleBlock = 58,
  CollapsibleOpenTag = 59,
  CollapsibleOpen = 60,
  CollapsibleClose = 62,
  CodeBlock = 63,
  CodeOpenTag = 64,
  CodeOpen = 65,
  GenericToken = 67,
  RawContent = 68,
  List1 = 69,
  List2 = 70,
  ModuleOpenToken = 71,
  HTMLOpenToken = 72,
  UserOpen = 73,
  FootnoteOpen = 74,
  FootnoteClose = 75,
  TabViewOpenToken = 76,
  TabViewCloseToken = 77,
  TabOpenToken = 78,
  TabCloseToken = 79,
  ImageOpen = 80,
  TableBar = 81,
  TableTilde = 82,
  Blockquote = 83,
  ForcedNewLine = 84,
  FootnoteBlock = 85,
  Title = 86,
  Monospace = 87,
  CodeClose = 88,
  UserBlock = 89,
  ModuleBlock = 92,
  ModuleOpenTag = 93,
  ModuleContent = 95,
  ModuleCloseToken = 96,
  Footnote = 97,
  ImageBlock = 99,
  HTMLBlock = 102,
  HTMLOpenTag = 103,
  HTMLContent = 105,
  HTMLCloseToken = 106,
  TabViewBlock = 107,
  TabBlock = 108
